import ColumnSet from '@/components/grid/columns/column-set';
import ColumnsDefinition from '@/common/definitions/columns/orders';

export default new ColumnSet({
    id: 'order-list',
    ...ColumnsDefinition,
});
